export default "__VITE_ASSET__Bh0gOh5i__"